import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AppPage from 'components/AppPage';
import RulerBar from 'components/RulerBar';

const css = oxygenCss({
  root: {
    textAlign: 'center',
    marginTop: '1em'
  }
});

class StripeCompletePurchase extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  componentDidMount() {
    const queryParams = this.props.location.query;
    const data = {
      ...queryParams
    };
    const event = new CustomEvent('stripeSecure3DSuccess', { detail: data });
    window.parent.document.dispatchEvent(event);
  }

  render() {
    return (
      <AppPage className='dashboard' header={<RulerBar title='' />}>
        <h1 className={css.root}>Payment complete</h1>
        <p className={css.root}>
          The course will soon appear on your dashboard once we have received a
          signal.
        </p>
      </AppPage>
    );
  }
}

export default StripeCompletePurchase;



// WEBPACK FOOTER //
// ./src/js/components/Store/StripeCompletePurchase.js